"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsFlarieDefaultDateFormat = exports.ValidateFlarieDefaultDate = void 0;
const class_validator_1 = require("class-validator");
let ValidateFlarieDefaultDate = class ValidateFlarieDefaultDate {
    validate(value) {
        return (function isValidated() {
            if (!value) {
                return true;
            }
            // if the date is invalid
            const date = new Date(value);
            if (date.toString() == 'Invalid Date') {
                return false;
            }
            // regex to check a date format is like yyyy-mm-dd hh:mm:ss
            const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
            if (!regex.test(value)) {
                return false;
            }
            return true;
        })();
    }
};
exports.ValidateFlarieDefaultDate = ValidateFlarieDefaultDate;
exports.ValidateFlarieDefaultDate = ValidateFlarieDefaultDate = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ async: true })
], ValidateFlarieDefaultDate);
/**
 * Checks if the value is a valid date format like 'YYYY-MM-DD HH:mm:ss'
 * @returns true if the value is a valid date format
 */
function IsFlarieDefaultDateFormat(validationOptions) {
    // eslint-disable-next-line @typescript-eslint/ban-types
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: 'IsFlarieDefaultDateFormat',
            target: object.constructor,
            propertyName: propertyName,
            options: Object.assign({ message: `${propertyName} must be a valid date string like YYYY-MM-DD HH:mm:ss` }, validationOptions),
            validator: ValidateFlarieDefaultDate,
        });
    };
}
exports.IsFlarieDefaultDateFormat = IsFlarieDefaultDateFormat;
